import { Typography } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'features/EntityDetails/components/EntityDetails/AllowedMimeTypes/AllowedMimeTypes.styles';
import ChipListDetail from 'features/EntityDetails/components/EntityDetails/ChipListDetail';

const ALLOWED_MIME_TYPES_SEPARATOR = ':';

type AllowedMimeTypesProps = {
  allowedMimeTypes: string | null;
  previousAllowedMimeTypes?: string | null;
};

const parseMimeTypes = (mimeTypes?: string | null): string[] => {
  return mimeTypes ? mimeTypes.split(ALLOWED_MIME_TYPES_SEPARATOR).map((type) => type.trim()) : [];
};

const AllowedMimeTypes = ({
  allowedMimeTypes,
  previousAllowedMimeTypes,
}: AllowedMimeTypesProps) => {
  const classes = useStyles();

  if (!allowedMimeTypes && !previousAllowedMimeTypes) {
    return (
      <div className={classes.root}>
        <Typography variant="body2" className={classes.label}>
          Allowed Mime Types
        </Typography>
        <Typography variant="body2" fontWeight={600} className={classes.notFoundValue}>
          Not Found
        </Typography>
      </div>
    );
  }

  return (
    <ChipListDetail
      headerText="Allowed Mime Types"
      items={parseMimeTypes(allowedMimeTypes)}
      previousItems={
        previousAllowedMimeTypes ? parseMimeTypes(previousAllowedMimeTypes) : undefined
      }
      getKey={(mimeType) => mimeType}
      getLabel={(mimeType) => mimeType}
    />
  );
};

export default AllowedMimeTypes;
